import AddState from "../../Components/Modals/AddState";
import Table from "../../Components/Table";
import { deleteStateById, getStates } from "../../Services/MasterService";

const State = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Alias",
            value: "alias"
        },
        {
            label: "Country",
            value: "country_name"
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddState data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getStates}
            columns={columns}
            title={"States Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteStateById}
        />
    );
}

export default State;